import { Observable, filter, of, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { Router } from '@angular/router';

export function isLoggedIn(): Observable<boolean> {
  const msalBroadcastService = inject(MsalBroadcastService);
  const msalService = inject(MsalService);
  const router = inject(Router);

  return msalBroadcastService.inProgress$.pipe(
    filter((status: InteractionStatus) => status === InteractionStatus.None),
    switchMap(() => {
      if (msalService.instance.getAllAccounts().length > 0) {
        return of(true);
      }

      router.navigate(['/']);
      return of(false);
    })
  );
}
